import gql from 'graphql-tag';

const NAME = 'compositions_CustomerWidget_updateCaseStoreCustomerMutation';

export default gql`
  mutation ${NAME} (
    $customerId: ID!
    $id: ID!,
    $zip: String,
    $city: String,
    $state: String,
  ) {
    setCaseStoreCustomer(
      input: {
        id: $id,
        patch: {
          customerId: $customerId,
          zip: $zip,
          city: $city,
          state: $state
        },
      },
    ) {
      case {
        id
        fixpixPushResult
        customer(useCachedDataForCase: true) {
          ... on StoreCustomer {
            accountNumber
            id
            name
            type
            zip
            city
            state
          }
        }
        paymentMethod
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/updateCaseStoreCustomerMutation.js